import { createApi } from '@reduxjs/toolkit/query/react'
import { createApiConfig } from '../../../../createApiConfig'

export const lmAppsDataApi = createApi({
  reducerPath: 'lmAppsDataApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['AppStoreData', 'AppStoreDataList', 'AppStoreDataMedia'],
  endpoints: builder => ({
    getAppStoreData: builder.query({
      query: (params) => ({
        url: `/links/app-store-data/`,
        params,
      }),
      providesTags: ['AppStoreData']
    }),
    createAppStoreData: builder.mutation({
      query: data => ({
        url: '/links/app-store-data/',
        method: 'POST',
        body: data
      }),
      invalidatesTags: ['AppStoreData']
    }),
    getAppStoreDataById: builder.query({
      query: ({ id, ...params }) => ({
        url: `/links/app-store-data/${id}/`,
        params,
      }),
      providesTags: ['AppStoreData']
    }),
    updateAppStoreData: builder.mutation({
      query: ({ id, body }) => ({
        url: `/links/app-store-data/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['AppStoreData']
    })
  })
})

export const {
  useGetAppStoreDataQuery,
  useLazyGetAppStoreDataQuery,
  useCreateAppStoreDataMutation,
  useUpdateAppStoreDataMutation,
  useGetAppStoreDataByIdQuery
} = lmAppsDataApi
